"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var React = require("react");
var text_filed_component_1 = require("../../../../common/text_filed/text_filed_component");
var conroldashboardstyles_1 = require("../../control_dashboard/list/conroldashboardstyles");
var AnswerTable_1 = require("./AnswerTable");
var LinearScale = function (_a) {
    var name = _a.name, question_type = _a.question_type, questionNum = _a.questionNum, numeric = _a.numeric, options = _a.options, totalAttempts = _a.totalAttempts, rating_options = _a.rating_options, _id = _a._id, auditType = _a.auditType;
    var classes = (0, conroldashboardstyles_1.useStyles)();
    var _b = React.useState(), label1 = _b[0], setLabel1 = _b[1];
    var _c = React.useState(), label2 = _c[0], setLabel2 = _c[1];
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var _e = React.useState({}), optionlist = _e[0], setOptionlist = _e[1];
    var handleDrawerClose = function () {
        setOpen(false);
    };
    var displayTableData = function (e) {
        setOpen(!open);
        setOptionlist(e);
    };
    React.useEffect(function () {
        options === null || options === void 0 ? void 0 : options.map(function (option) {
            if (option.label1) {
                setLabel1(option.label1);
            }
            else if (option.label2) {
                setLabel2(option.label2);
            }
        });
    }, []);
    return (React.createElement("div", { className: "question-container" },
        React.createElement("div", { className: "question-wrapper" },
            React.createElement("span", { className: "sr-no" }, "Q".concat(questionNum, ".")),
            React.createElement(text_filed_component_1.default, { label: name, isDisabled: true }),
            React.createElement("div", { className: "audit-attempts-wrapper" },
                React.createElement("p", { className: "attempts-label" }, "Total Attempts"),
                React.createElement("p", { className: "attempts-value" }, totalAttempts))),
        React.createElement("div", { className: "options-container audit-summary-options" },
            React.createElement("div", { className: "linear-summary-wrapper" },
                React.createElement("div", { className: "linear-scale-conatiner flex-dr-col linear-summary-wrapper" },
                    React.createElement("label", { className: "linear-scale-label" }, label1),
                    React.createElement("div", { className: "linear-scale" },
                        React.createElement(material_1.FormControl, { className: "linear-from-control" },
                            React.createElement(material_1.RadioGroup, { "aria-labelledby": "demo-form-control-label-placement", name: "position", defaultValue: "top" }, rating_options === null || rating_options === void 0 ? void 0 : rating_options.map(function (label) {
                                return (React.createElement("div", { className: "linear-opt-wrapper displayflex" },
                                    React.createElement(material_1.FormControlLabel, { value: label.option, control: React.createElement(material_1.Radio, null), label: label.option, labelPlacement: "end", disabled: true }),
                                    React.createElement("div", { className: "progress-label-wrapper" },
                                        React.createElement("div", { className: "progress-bar-wrapper" },
                                            React.createElement(material_1.LinearProgress, { variant: "determinate", value: label.percentage
                                                    ? parseInt(label.percentage)
                                                    : 0, color: "success" })),
                                        React.createElement("label", { className: "progress-label" },
                                            label.percentage ? parseInt(label.percentage) : 0,
                                            "%"),
                                        React.createElement(material_1.IconButton, { className: parseInt(label.percentage) > 0
                                                ? "icon-btn"
                                                : "icon-btn icon-disabled", disabled: parseInt(label.percentage) > 0 ? false : true, onClick: function () { return displayTableData(label); } },
                                            React.createElement("span", { className: "icon-Vector" })))));
                            })))),
                    React.createElement("label", { className: "linear-scale-label" }, label2)))),
        open ?
            React.createElement(material_1.Drawer, { variant: "temporary", anchor: "bottom", open: open, className: classes.customDrawer },
                React.createElement("div", { onClick: handleDrawerClose, className: "drawer-close-btn" },
                    React.createElement("span", { className: "icon-close" })),
                React.createElement(AnswerTable_1.default, { option: optionlist, question_id: _id, name: name, question_type: question_type, auditType: auditType })) : ''));
};
exports.default = LinearScale;
